import { useSelectAllExitIntents } from '../state/actions/useSelectAllExitIntents';
import { useUnselectAllExitIntent } from '../state/actions/useUnselectAllExitIntent';
import { useRemoveTriggerType } from '../state/actions/useRemoveTriggerType';
import { useExitIntentAreasSelector } from '../state/selectors/useExitIntentAreasSelector';
import { useTriggerSelector } from '../state/selectors/useTriggerSelector';
import { useInactivitySelector } from '../state/selectors/useInactivitySelector';
import { useSetInactivity } from '../state/actions/useSetInactivity';
import { useSelectedTriggers } from '../state/selectors/useSelectedTriggers';
import { useAddTriggerType } from '../state/actions/useAddTriggerType';
import { useSetExitIntent } from '../state/actions/useSetExitIntent';
import { useSetOnClick } from '../state/actions/useSetOnClick';
import { useOnClickSelector } from '../state/selectors/useOnClickSelector';
import { useSegmentationSelector } from '../state/selectors/useSegmentationSelector';
import { useClearSegmentation } from '../state/actions/useClearSegmentation';
import { useSegmentationChosen } from '../state/actions/useSegmentationChosen';
import { useSaveTriggerSegmentation } from '../state/actions/useSaveTriggerSegmentation';
import { useGetFrequencySelector } from '../state/selectors/useGetFrequencySelector';
import { useSetFrequency } from '../state/actions/useSetFrequency';

export const useTrigger = () => {
  const selectAllExitIntents = useSelectAllExitIntents();
  const unselectAllExitIntent = useUnselectAllExitIntent();
  const removeTriggerType = useRemoveTriggerType();
  const setInactivity = useSetInactivity();
  const addTriggerType = useAddTriggerType();
  const setExitIntent = useSetExitIntent();
  const setOnClick = useSetOnClick();
  const clearSegmentation = useClearSegmentation();
  const segmentationChosen = useSegmentationChosen();
  const saveTriggerSegmentation = useSaveTriggerSegmentation();
  const setFrequency = useSetFrequency();

  const trigger = useTriggerSelector();
  const exitIntentAreas = useExitIntentAreasSelector();
  const inactivity = useInactivitySelector();
  const onClick = useOnClickSelector();
  const selectedTriggers = useSelectedTriggers();
  const segmentation = useSegmentationSelector();
  const getFrequency = useGetFrequencySelector();

  return {
    selectAllExitIntents,
    unselectAllExitIntent,
    removeTriggerType,
    setInactivity,
    addTriggerType,
    setExitIntent,
    setOnClick,
    clearSegmentation,
    segmentationChosen,
    saveTriggerSegmentation,
    setFrequency,

    trigger,
    exitIntentAreas,
    inactivity,
    onClick,
    selectedTriggers,
    segmentation,
    getFrequency,
  };
};
